// 物业仓储仓单 报修管理
// import { h } from 'vue';
export const repairOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'name',
      title: '名称',
      visible: true,
    },
    {
      field: 'repairNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'repairDate',
      title: '报修时间',
      visible: true,
    },
    {
      field: 'auditStatus',
      title: '状态',
      visible: true,
    },
  ];
};

export const repairApprovalData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'name',
      title: '名称',
      visible: true,
    },
    {
      field: 'repairNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 物业仓储仓单 租赁合同、仓储合同、监管合同、三方监管
export const parkOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};

export const parkApprovalData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 物业仓储仓单、多式联运、成矿、物贸 应收结算
export const receiveOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'receivableSettlementName',
      title: '名称',
      visible: true,
    },
    {
      field: 'receivableSettlementNo',
      title: '单据号',
      slots: {
        default: ({ row }) => {
          return [
            <a href="#" onClick={() => this.dblclickEvent(row)}>
              {row.receivableSettlementNo}
            </a>,
            //  row.receivableSettlementNo
          ];
        },
      },
      visible: true,
    },
    {
      field: 'settlementDate',
      title: '结算日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};

export const receiveApprovalData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'receivableSettlementName',
      title: '名称',
      visible: true,
    },
    {
      field: 'receivableSettlementNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 多式联运、成矿、物贸 应付结算
export const payOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'paySettlementName',
      title: '名称',
      visible: true,
    },
    {
      field: 'payableSettlementNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};

export const payApprovalData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'paySettlementName',
      title: '名称',
      visible: true,
    },
    {
      field: 'payableSettlementNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 多式联运 项目
export const multimodalTransportProjectOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'applyDate',
      title: '立项申请时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const multimodalTransportProjectApprovalData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 多式联运 客方合同、供方合同
export const multimodalTransportCustomerContractOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'contractSignDate',
      title: '合同签订时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const multimodalTransportCustomerContractApprovalData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 多式联运 销售发票申请
export const saleInvoiceOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'invoiceName',
      title: '名称',
      visible: true,
    },
    {
      field: 'invoiceNum',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};

export const saleInvoiceData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'invoiceName',
      title: '名称',
      visible: true,
    },
    {
      field: 'invoiceNum',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 多式联运 付款申请
export const paymentOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'payeeName',
      title: '名称',
      visible: true,
    },
    {
      field: 'paymentApplyNumber',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};

export const paymentData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'paymentApplyName',
      title: '名称',
      visible: true,
    },
    {
      field: 'paymentApplyNumber',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 城矿 贸易立项
export const projectInitiationOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};

export const projectInitiationData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 城矿 销售协议、销售合同
export const salePurchaseOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      slots: {
        default: ({ row }) => {
          return [<a>{row.contractNo}</a>];
        },
      },
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'contractStatusName',
      title: '状态',
      visible: true,
    },
  ];
};

export const salePurchaseData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 城矿 采购合同
export const purchaseOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'contractStatusName',
      title: '状态',
      visible: true,
    },
  ];
};
export const purchaseData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 城矿 应付结算、应收结算
// export const settlementOnGoingData = () => {
//   return [
//     { type: 'seq', title: '序号', width: 50 },
//     {
//       field: 'orderTypeName',
//       title: '单据类型',
//       visible: true,
//     },
//     {
//       field: 'payableSettlementName',
//       title: '名称',
//       visible: true,
//     },
//     {
//       field: 'payableSettlementNo',
//       title: '单据号',
//       visible: true,
//     },
//     {
//       field: 'gmtCreate',
//       title: '创建日期',
//       visible: true,
//     },
//     {
//       field: 'statusMap',
//       title: '状态',
//       visible: true,
//     },
//   ];
// };
// export const settlementData = () => {
//   return [
//     { type: 'seq', title: '序号', width: 50 },
//     {
//       field: 'orderTypeName',
//       title: '单据类型',
//       visible: true,
//     },
//     {
//       field: 'payableSettlementName',
//       title: '名称',
//       visible: true,
//     },
//     {
//       field: 'payableSettlementNo',
//       title: '单据号',
//       visible: true,
//     },
//     {
//       field: 'approvalPerson',
//       title: '审批人',
//       visible: true,
//     },
//   ];
// };
// 城矿 销售发票申请
export const chengkuangSaleInvoiceOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'invoiceName',
      title: '名称',
      visible: true,
    },
    {
      field: 'invoiceNum',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const chengkuangSaleInvoiceData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'invoiceName',
      title: '名称',
      visible: true,
    },
    {
      field: 'invoiceNum',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// invoiceNum
// 城矿 付款申请
export const chengkuangPayOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'payeeName',
      title: '名称',
      visible: true,
    },
    {
      field: 'paymentApplyNumber',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const chengkuangPayData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'payeeName',
      title: '名称',
      visible: true,
    },
    {
      field: 'paymentApplyNumber',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 物贸 销售合同、双边合同
export const wumaoContractOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const wumaoContractData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 服务合同
export const wumaoServiceContractOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const wumaoServiceContractData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'contractName',
      title: '名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 物贸 采购合同
export const wumaopurchaseOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const wumaopurchaseData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 物贸 信用证开征查询
export const issueCreditOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'applyName',
      title: '名称',
      visible: true,
    },
    {
      field: 'applyNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const issueCreditData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'applyName',
      title: '名称',
      visible: true,
    },
    {
      field: 'applyNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 物贸 立项
export const wumaoProjectOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const wumaoProjectData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'projectName',
      title: '名称',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 物贸 应付结算

// 物贸 应收结算

// 物贸 销售发票申请
export const wumaoSaleInvoiceOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'invoiceName',
      title: '名称',
      visible: true,
    },
    {
      field: 'invoiceNum',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const wumaoSaleInvoiceData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'invoiceName',
      title: '名称',
      visible: true,
    },
    {
      field: 'invoiceNum',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 物贸 付款申请
export const wumaopaymentOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'paymentApplyName',
      title: '名称',
      visible: true,
    },
    {
      field: 'paymentApplyNumber',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建日期',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const wumaopaymentData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'paymentApplyName',
      title: '名称',
      visible: true,
    },
    {
      field: 'paymentApplyNumber',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 主数据 合作伙伴
export const cooperationOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'partnerZhName',
      title: '名称',
      visible: true,
    },
    {
      field: 'partnerCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'requestTime',
      title: '申请时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const cooperationData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'partnerZhName',
      title: '名称',
      visible: true,
    },
    {
      field: 'partnerCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 商品主数据
export const goodsOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'partnerZhName',
      title: '名称',
      visible: true,
    },
    {
      field: 'partnerCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const goodsData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'partnerZhName',
      title: '名称',
      visible: true,
    },
    {
      field: 'partnerCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};
// 商品子类主数据
export const goodsChildOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'productChName',
      title: '名称',
      visible: true,
    },
    {
      field: 'productDetailCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const goodsChildData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'productChName',
      title: '名称',
      visible: true,
    },
    {
      field: 'productDetailCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 仓库主数据（一级仓库）
export const firstLevelOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'storageName',
      title: '名称',
      visible: true,
    },
    {
      field: 'storageCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'storageCreateTime',
      title: '创建时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const firstLevelData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'storageName',
      title: '名称',
      visible: true,
    },
    {
      field: 'storageCode',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 人员
export const personnelOnGoingData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'personName',
      title: '名称',
      visible: true,
    },
    {
      field: 'personNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'gmtCreate',
      title: '创建时间',
      visible: true,
    },
    {
      field: 'statusMap',
      title: '状态',
      visible: true,
    },
  ];
};
export const personnelData = () => {
  return [
    { type: 'seq', title: '序号', width: 50 },
    {
      field: 'orderTypeName',
      title: '单据类型',
      visible: true,
    },
    {
      field: 'personName',
      title: '名称',
      visible: true,
    },
    {
      field: 'personNo',
      title: '单据号',
      visible: true,
    },
    {
      field: 'approvalPerson',
      title: '审批人',
      visible: true,
    },
  ];
};

// 园区、仓储、仓单
export const tableTitleMap = {
  租赁合同: { onGoingColumn: parkOnGoingData(), approvalColumn: parkApprovalData() },
  物业合同: { onGoingColumn: parkOnGoingData(), approvalColumn: parkApprovalData() },
  仓储合同: { onGoingColumn: parkOnGoingData(), approvalColumn: parkApprovalData() },
  监管合同: { onGoingColumn: parkOnGoingData(), approvalColumn: parkApprovalData() },
  三方监管: { onGoingColumn: parkOnGoingData(), approvalColumn: parkApprovalData() },
  报修管理: { onGoingColumn: repairOnGoingData(), approvalColumn: repairApprovalData() },
  应收结算: { onGoingColumn: receiveOnGoingData(), approvalColumn: receiveApprovalData() },
  人员: { onGoingColumn: personnelOnGoingData(), approvalColumn: personnelData() },
  仓库: { onGoingColumn: firstLevelOnGoingData(), approvalColumn: firstLevelData() },
  商品子类: { onGoingColumn: goodsChildOnGoingData(), approvalColumn: goodsChildData() },
  商品: { onGoingColumn: goodsOnGoingData(), approvalColumn: goodsChildData() },
  合作伙伴: { onGoingColumn: cooperationOnGoingData(), approvalColumn: cooperationData() },
};
// 多式联运
export const multimodalTransportTableTitleMap = {
  项目: {
    onGoingColumn: multimodalTransportProjectOnGoingData(),
    approvalColumn: multimodalTransportProjectApprovalData(),
  },
  客方合同: {
    onGoingColumn: multimodalTransportCustomerContractOnGoingData(),
    approvalColumn: multimodalTransportCustomerContractApprovalData(),
  },
  供方合同: {
    onGoingColumn: multimodalTransportCustomerContractOnGoingData(),
    approvalColumn: multimodalTransportCustomerContractApprovalData(),
  },
  应付结算: { onGoingColumn: payOnGoingData(), approvalColumn: payApprovalData() },
  销售发票申请: { onGoingColumn: saleInvoiceOnGoingData(), approvalColumn: saleInvoiceData() },
  付款申请: { onGoingColumn: paymentOnGoingData(), approvalColumn: paymentData() },
  人员: { onGoingColumn: personnelOnGoingData(), approvalColumn: personnelData() },
  仓库: { onGoingColumn: firstLevelOnGoingData(), approvalColumn: firstLevelData() },
  商品子类: { onGoingColumn: goodsChildOnGoingData(), approvalColumn: goodsChildData() },
  商品: { onGoingColumn: goodsOnGoingData(), approvalColumn: goodsChildData() },
  合作伙伴: { onGoingColumn: cooperationOnGoingData(), approvalColumn: cooperationData() },
};
// 城矿
export const chengkuangTableTitleMap = {
  贸易立项: {
    onGoingColumn: projectInitiationOnGoingData(),
    approvalColumn: projectInitiationData(),
  },
  销售协议: { onGoingColumn: salePurchaseOnGoingData(), approvalColumn: salePurchaseData() },
  销售合同: { onGoingColumn: salePurchaseOnGoingData(), approvalColumn: salePurchaseData() },
  采购合同: { onGoingColumn: purchaseOnGoingData(), approvalColumn: purchaseData() },
  应付结算: { onGoingColumn: payOnGoingData(), approvalColumn: payApprovalData() },
  应收结算: { onGoingColumn: receiveOnGoingData(), approvalColumn: receiveApprovalData() },
  销售发票申请: {
    onGoingColumn: chengkuangSaleInvoiceOnGoingData(),
    approvalColumn: saleInvoiceData(),
  },
  付款申请: { onGoingColumn: chengkuangPayOnGoingData(), approvalColumn: chengkuangPayData() },
  人员: { onGoingColumn: personnelOnGoingData(), approvalColumn: personnelData() },
  仓库: { onGoingColumn: firstLevelOnGoingData(), approvalColumn: firstLevelData() },
  商品子类: { onGoingColumn: goodsChildOnGoingData(), approvalColumn: goodsChildData() },
  商品: { onGoingColumn: goodsOnGoingData(), approvalColumn: goodsChildData() },
  合作伙伴: { onGoingColumn: cooperationOnGoingData(), approvalColumn: cooperationData() },
};
// 物贸
export const wumaoTableTitleMap = {
  信用证开征查询: {
    onGoingColumn: issueCreditOnGoingData(),
    approvalColumn: issueCreditData(),
  },
  销售合同: { onGoingColumn: wumaoContractOnGoingData(), approvalColumn: wumaoContractData() },
  服务合同: {
    onGoingColumn: wumaoServiceContractOnGoingData(),
    approvalColumn: wumaoServiceContractData(),
  },
  采购合同: { onGoingColumn: purchaseOnGoingData(), approvalColumn: purchaseData() },
  双边合同: { onGoingColumn: wumaoContractOnGoingData(), approvalColumn: wumaoContractData() },
  立项: { onGoingColumn: wumaoProjectOnGoingData(), approvalColumn: wumaoProjectData() },
  应付结算: { onGoingColumn: payOnGoingData(), approvalColumn: payApprovalData() },
  应收结算: { onGoingColumn: receiveOnGoingData(), approvalColumn: receiveApprovalData() },
  销售发票申请: {
    onGoingColumn: wumaoSaleInvoiceOnGoingData(),
    approvalColumn: wumaoSaleInvoiceData(),
  },
  付款申请: { onGoingColumn: wumaopaymentOnGoingData(), approvalColumn: wumaopaymentData() },
  人员: { onGoingColumn: personnelOnGoingData(), approvalColumn: personnelData() },
  仓库: { onGoingColumn: firstLevelOnGoingData(), approvalColumn: firstLevelData() },
  商品子类: { onGoingColumn: goodsChildOnGoingData(), approvalColumn: goodsChildData() },
  商品: { onGoingColumn: goodsOnGoingData(), approvalColumn: goodsChildData() },
  合作伙伴: { onGoingColumn: cooperationOnGoingData(), approvalColumn: cooperationData() },
};
